(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/selectors/last-searched.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/selectors/last-searched.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  normalizeCardData
} = svs.components.casino_react.common.utils;
function useLastSearchedSelector() {
  const lastSearched = useSelector(state => {
    const parsedLastSearched = state.lastSearched.map(typeAndSystemName => {
      const [typeParam, systemName] = typeAndSystemName.split('_');
      return normalizeCardData({
        name: systemName,
        systemName
      }, typeParam);
    });
    return parsedLastSearched;
  });
  return lastSearched;
}
setGlobal('svs.components.casino_react.casinoStore.selectors.useLastSearchedSelector', useLastSearchedSelector);

 })(window);